import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { MASKS } from 'ng-brazil';
import { OrcStatus } from 'src/app/models/orc-status';
import { CarregandoService } from 'src/app/services/carregando.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { OrcStatusService } from 'src/app/services/orc-status.service';
import { ViaCepService } from 'src/app/services/via-cep.service';

@Component({
  selector: 'app-cadastrar-orc-status',
  templateUrl: './cadastrar-orc-status.component.html',
  styleUrls: ['./cadastrar-orc-status.component.scss']
})
export class CadastrarOrcStatusComponent implements OnInit {

  // variáveis
  idOrcStatus;
  orcStatus = new OrcStatus();
  editando = false;
  carregando = true;
  public MASKS = MASKS;
  editavel = true;
  padrao = false;
  pegouFranquia = false;
  tipos = [{ id: 0, nome: 'Normal' }, { id: 1, nome: 'Mercado Pago' }];
  tipo = 0;
  texto = 'Orçamento';

  constructor(private route: ActivatedRoute, private notificacaoService: NotificacaoService,
    private orcStatusService: OrcStatusService,
    private router: Router,
    private globalService: GlobalService, private carregandoService: CarregandoService) { }

  ngOnInit() {

    this.route.data.subscribe((data: Data) => {
      this.tipo = data['tipo'];
      this.texto = this.tipo === 0 ? 'Orçamento' : 'Repasse';

      // se for edição, busca o orcStatus do id passado
      if (this.route.snapshot.paramMap.get('id')) {
        this.idOrcStatus = this.route.snapshot.paramMap.get('id');
        this.editando = true;
        this.buscarOrcStatus();
      } else {
        this.orcStatus = new OrcStatus();
        this.atualizaDadosOrcStatus();
      }
    });


  }

  ngAfterViewInit(): void {

  }

  buscarOrcStatus() {

    this.carregandoService.mostra('buscaOrcStatus');

    this.orcStatusService.consultarPorId(this.idOrcStatus).subscribe(age => {
      this.orcStatus = age;
      this.atualizaDadosOrcStatus();
    }, (erro) => {
      this.carregandoService.esconde('buscaOrcStatus');
      this.notificacaoService.erro(erro);
    });
  }

  atualizaDadosOrcStatus() {

    this.carregando = false;

    this.carregandoService.esconde('buscaOrcStatus');
  }

  salvar() {
    this.carregandoService.mostra('salvaOrcStatus');

    this.orcStatus.tipo = this.tipo;
    this.orcStatusService.salvar(this.orcStatus).subscribe(() => {
      this.notificacaoService.sucesso('Status salvo com sucesso!!!');
      this.router.navigate(['configuracoes/' + (this.tipo === 0 ? 'orc-status' : 'repasse-status')]).then(() => {
        this.carregandoService.esconde('salvaOrcStatus');
      });

    }, (erro) => {
      this.carregandoService.esconde('salvaOrcStatus');
      this.notificacaoService.erro(erro);
    });
  }

  ngOnDestroy(): void { }
}
